<template>
  <div class="content written-off-order-list">
    <section style="margin-bottom: 1%">
      <a-button type="primary" @click="createHandle">
        <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
        {{ $t('新增核销单') }}
      </a-button>
    </section>
    <div class="form-content">
      <a-tabs v-model="active_tab" @change="tabChange">
        <a-tab-pane key="RECEIVABLE_RECEIPT" :tab="$t('应收收款')" />
        <a-tab-pane key="RECEIVABLE_REFUND" :tab="$t('应收退款')" />
        <a-tab-pane key="RECEIVABLE_HEDGE" :tab="$t('应收对冲')" />
      </a-tabs>
      <a-row :gutter="16" style="margin-top: 15px">
        <a-col :span="6">
          <CommonSelect
            :isBu="true"
            :list="$store.state.settlementBuList"
            :placeholder="$t('结算组织')"
            :code.sync="formData.businessUnitCode"
            @change="searchHandle(1)"
          />
        </a-col>
        <a-col :span="6">
          <a-input
            allow-clear
            v-model.trim="formData.main_doc_sn"
            :placeholder="$t('请输入应收单号')"
          />
        </a-col>
        <a-col :span="6">
          <CommonSelect
            :list="$store.state.contact_type"
            :placeholder="$t('收款方类型')"
            :code.sync="formData.payeeType"
          />
        </a-col>
      </a-row>
      <a-row :gutter="16" class="mt10">
        <a-col :span="6">
          <a-input allow-clear v-model.trim="formData.payeeCode" :placeholder="$t('收款方编码')" />
        </a-col>
        <a-col :span="6">
          <a-select
            v-model="formData.needGenerateVoucher"
            allow-clear
            :placeholder="$t('能否生成凭证')"
            style="width: 100%"
          >
            <a-select-option :value="1">{{ $t('需要') }}</a-select-option>
            <a-select-option :value="0">{{ $t('不需要') }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6">
          <a-select
            v-model="formData.voucherGenerated"
            allow-clear
            :placeholder="$t('已生成凭证')"
            style="width: 100%"
          >
            <a-select-option :value="1">{{ $t('是') }}</a-select-option>
            <a-select-option :value="0">{{ $t('否') }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6">
          <a-button @click="searchHandle(1)" type="primary">
            <i class="iconfont" style="margin-right: 5px">&#xe647;</i>
            {{ $t(`查询`) }}
          </a-button>
          <a-button @click="reset">
            <a-icon type="redo" />
            {{ $t(`重置`) }}
          </a-button>
        </a-col>
      </a-row>
    </div>
    <div class="table-content">
      <div class="table-height flex-ct">
        <VoucherBtn
          :doc_type="doc_type"
          :selected_rows="selected_rows"
          :disabled="selected_rows.length === 0"
          @close="searchHandle"
        />
        <OperateBtn
          v-if="$store.getters.hasFunction('receivable_writeoff_cancel')"
          class="ml10"
          api="cancelWrittenOff"
          type="danger"
          :text="$t('反核销')"
          :params="{ writtenOffType: 'ReceivableWrittenOff', idList: selected_row_keys }"
          :disabled="selected_row_keys.length === 0"
          @success="searchHandle"
        />
      </div>
      <div class="table-body mt10">
        <a-table
          size="small"
          :row-selection="{
            selectedRowKeys: selected_row_keys,
            onChange: onSelectChange,
          }"
          :columns="columns"
          :loading="loading"
          :dataSource="table_data"
          :scroll="{ x: 1500 }"
          rowKey="id"
          :pagination="false"
        >
          <template slot="no" slot-scope="text, record, index">
            <span>{{ index + 1 }}</span>
          </template>
          <template slot="main_doc_sn" slot-scope="text, record">
            <span class="text-link" @click="jumpSoucePage(record.main_doc_sn, record.main_doc_id)">
              {{ record.main_doc_sn }}
            </span>
          </template>
          <template slot="written_off_amount" slot-scope="text, record">
            <PriceInput :value="text" :currency="record.settlement_currency" :showTxt="true" />
          </template>
          <template slot="expandedRowRender" slot-scope="record">
            <CommonTable
              style="background: #fff"
              :dataSource="record.details"
              :columns="detail_columns"
              :showSetting="false"
              :showPagination="false"
              rowKey="id"
            >
              <template v-slot:refer_doc_sn="{ record }">
                <span
                  class="text-link"
                  @click="jumpSoucePage(record.refer_doc_sn, record.refer_doc_id)"
                >
                  {{ record.refer_doc_sn }}
                </span>
              </template>
              <template v-slot:written_off_amount="{ text }">
                <PriceInput :showTxt="true" :value="text" />
              </template>
            </CommonTable>
          </template>
        </a-table>
      </div>
      <div class="table-footer mt10">
        <pagination
          :pageNo="page_no"
          :length="page_size"
          :total-count="total"
          @paginate="paginate"
        ></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import http from '@/service/axios'
import api from '@/service/api'
import pagination from '@/component/pagination.vue'
import { jumpSoucePage } from '@/common'
export default {
  name: 'WrittenOffOrderList',
  components: { pagination },
  data() {
    return {
      doc_type: 'ReceivableWrittenOff',
      active_tab: 'RECEIVABLE_RECEIPT',
      formData: {
        main_doc_sn: '',
        payeeType: undefined,
        payeeCode: undefined,
        needGenerateVoucher: undefined,
        voucherGenerated: undefined,
      },
      table_data: [],
      selected_rows: [],
      selected_row_keys: [],
      loading: false,
      total: 0,
      page_no: 1,
      page_size: 20,
    }
  },
  activated() {
    this.searchHandle()
  },
  computed: {
    ...mapGetters(['writtenOffTypeMapping', 'contactTypeMapping']),
    columns() {
      return [
        {
          title: '#',
          align: 'center',
          key: 'NO',
          width: 60,
          scopedSlots: {
            customRender: 'no',
          },
        },
        {
          title: this.$t('核销序号'),
          data_index: 'written_off_sn',
          dataIndex: 'written_off_sn',
          width: 220,
        },
        {
          title: this.$t('核销类型'),
          dataIndex: 'written_off_type',
          width: 120,
          customRender: (text) => this.writtenOffTypeMapping[text],
        },
        {
          title: this.$t('核销日期'),
          dataIndex: 'written_off_date',
        },
        {
          title: this.$t('应收单号'),
          dataIndex: 'main_doc_sn',
          width: 200,
          scopedSlots: { customRender: 'main_doc_sn' },
        },
        {
          title: this.$t('核销金额'),
          dataIndex: 'written_off_amount',
          width: 120,
          scopedSlots: { customRender: 'written_off_amount' },
        },
        {
          title: this.$t('结算组织'),
          dataIndex: 'business_unit_name',
        },
        {
          title: this.$t('收款方类型'),
          dataIndex: 'payeeType',
          customRender: (text, record) =>
            this.contactTypeMapping[record.payeeType ?? record.payee_type] ||
            record.payeeType ||
            record.payee_type ||
            '',
        },
        {
          title: this.$t('收款方名称'),
          dataIndex: 'payeeName',
          customRender: (text, record) => record.payeeName || record.payee_name || '',
        },
        {
          title: this.$t('能否生成凭证'),
          dataIndex: 'need_generate_voucher',
          width: 100,
          customRender: (text, record) => {
            const val = record.needGenerateVoucher ?? record.need_generate_voucher
            return val === 1 ? this.$t('需要') : val === 0 ? this.$t('不需要') : ''
          },
        },
        {
          title: this.$t('是否生成凭证'),
          dataIndex: 'voucher_generated',
          width: 100,
          customRender: (text) => (text ? this.$t('是') : this.$t('否')),
        },
        {
          title: this.$t('凭证号'),
          dataIndex: 'voucher_no',
          width: 100,
        },
        {
          title: this.$t('创建人'),
          dataIndex: 'created_user',
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'created_at',
        },
      ]
    },
    detail_columns() {
      const referTitleMap = {
        RECEIVABLE_RECEIPT: this.$t('收款单号'),
        RECEIVABLE_REFUND: this.$t('付款单号'),
        RECEIVABLE_HEDGE: this.$t('应收单号'),
      }
      let list = [
        {
          title: referTitleMap[this.active_tab] || this.$t('关联单号'),
          dataIndex: 'refer_doc_sn',
          width: 200,
          scopedSlots: { customRender: 'refer_doc_sn' },
        },
        {
          title: this.$t('核销金额'),
          dataIndex: 'written_off_amount',
          width: 220,
          scopedSlots: {
            customRender: 'written_off_amount',
          },
        },
      ]
      return list
    },
  },
  methods: {
    jumpSoucePage,
    ...mapMutations(['addPane']),
    reset() {
      Object.assign(this.$data, this.$options.data())
      this.searchHandle(1)
    },
    tabChange() {
      this.searchHandle(1)
    },
    searchHandle(page_no) {
      this.selected_rows = []
      this.selected_row_keys = []
      this.queryList(page_no)
    },
    createHandle() {
      this.$router.push({
        name: 'createWrittenOffOrder',
        query: { written_off_type: this.active_tab },
      })
    },
    async queryList(page_no = 0) {
      if (!this.formData.businessUnitCode) return
      if (page_no) {
        this.page_no = page_no
      }
      this.loading = true
      await http({
        url: api.getReceivableWrittenOffList,
        data: {
          page_no: this.page_no,
          page_size: this.page_size,
          written_off_type: this.active_tab,
          ...this.formData,
        },
        success: (res) => {
          this.table_data = res.result.list
          this.total = res.result.total
        },
      })
      this.loading = false
    },
    onSelectChange(selected_row_keys, selected_rows) {
      this.selected_row_keys = selected_row_keys
      this.selected_rows = selected_rows
    },
    paginate(data) {
      this.page_no = data.page_no
      this.page_size = data.page_size
      this.queryList()
    },
  },
}
</script>
